export const getGroupedPhotoPricingPrintProducts = photoPricingPrintProducts => {
  return photoPricingPrintProducts.reduce((acc, val) => {
    const printProduct = acc.find(pp => pp.id === val.print_product.id);

    if (!printProduct) {
      return [
        ...acc,
        {
          ...val.print_product,
          sizes: {
            records: [
              {
                ...val.print_product_size,
                price: val.price,
              },
            ],
            total: 1,
          },
        },
      ];
    }

    return acc.map(pp =>
      pp.id === printProduct.id
        ? {
            ...pp,
            sizes: {
              records: [
                ...pp.sizes.records,
                {
                  ...val.print_product_size,
                  price: val.price,
                },
              ],
              total: pp.sizes.total + 1,
            },
          }
        : pp,
    );
  }, []);
};
